import { useState, useEffect } from "react";
import { Box, makeStyles, Typography, Grid } from "@material-ui/core";

import { BY_MY } from "../../../../constants";
import { SAVE_THE_PLANET_COLORS, SAVE_THE_PLANET_LEGENDS } from "../../constants";
import { Toggle } from "../../../../components/toggle";
import { ShaDowBox } from "../../../../components/boxes/ShadowBox";
import { NoDataCard } from "../../../../components/parts";
import { api, requestDateFormat } from "../../../../services";
import { StackedAreaChart } from "../../../../components/charts/StackedAreaChart";

const useStyles = makeStyles((theme) => ({
  box: {
    padding: `${theme.spacing(3)}px ${theme.spacing(3.5)}px`,
  },
  areaChart: {
    marginTop: `${theme.spacing(5.25)}px`,
    height: "240px",
  },
  span: {
    color: "#9FA2B4",
    fontSize: 14,
    marginTop: 5,
  },
}));

export const CarbonReductionOverTime = ({ period, startDate, endDate }) => {
  const classes = useStyles();
  const [data, setData] = useState([]);
  const [byFilter, setByFilter] = useState();
  const [defaultFilter, setDefaultFilter] = useState();
  const [currentUrl, setCurrentUrl] = useState();

  useEffect(() => {
    const getCarbonReductionOverTime = (url) => {
      api.get(url).then((resp) => {
        const data = resp.data.results.map((item) => {
          const date = new Date(item.date);
          return {
            ...item,
            x: `${date.getUTCFullYear()}-${date.getUTCMonth() + 1}`,
          };
        });
        setData(data);
        setDefaultFilter(resp.data.date_format === "year" ? BY_MY[1] : BY_MY[0]);
      });
    };

    setByFilter(null);
    let url = "/praas/v1/emission-impact/save-the-planet/carbon-reduction-over-time/";
    if (period.name === "RANGE" && endDate) {
      url += `?from_date=${requestDateFormat(startDate)}&to_date=${requestDateFormat(endDate)}`;
      getCarbonReductionOverTime(url);
      setCurrentUrl(url);
    } else if (["YTD", "Acc.", "20Y"].includes(period.name)) {
      url += `?date_filter=${period.filter}`;
      getCarbonReductionOverTime(url);
      setCurrentUrl(url);
    }
  }, [period, startDate, endDate]);

  useEffect(() => {
    if (byFilter) {
      let dateFormat = `date_format=${byFilter === BY_MY[0] ? "month" : "year"}`;

      api.get(`${currentUrl}&${dateFormat}`).then((resp) => {
        const data = resp.data.results.map((item) => {
          const date = new Date(item.date);
          return {
            ...item,
            x: `${date.getUTCFullYear()}-${date.getUTCMonth() + 1}`,
          };
        });
        setData(data);
      });
    }
  }, [currentUrl, byFilter]);

  const areas = [
    {
      key: "trading",
      stroke: SAVE_THE_PLANET_COLORS[SAVE_THE_PLANET_LEGENDS.TRADING],
      fill: SAVE_THE_PLANET_COLORS[SAVE_THE_PLANET_LEGENDS.TRADING],
    },
    {
      key: "battery",
      stroke: SAVE_THE_PLANET_COLORS[SAVE_THE_PLANET_LEGENDS.BATTERY],
      fill: SAVE_THE_PLANET_COLORS[SAVE_THE_PLANET_LEGENDS.BATTERY],
    },
    {
      key: "ev",
      stroke: SAVE_THE_PLANET_COLORS[SAVE_THE_PLANET_LEGENDS.EV],
      fill: SAVE_THE_PLANET_COLORS[SAVE_THE_PLANET_LEGENDS.EV],
    },
  ];

  return (
    <ShaDowBox style={{ width: "100%" }}>
      {data.length ? (
        <div className={classes.box} id="carbon-reduction-over-time">
          <Grid container justifyContent="space-between" alignItems="center">
            <Grid item>
              <Typography variant="h4" style={{ marginRight: 3 }}>
                Carbon Emission Reduction Over Time
              </Typography>
            </Grid>
            <Grid
              container
              item
              justifyContent="space-between"
              alignItems="center"
              style={{ flex: 1, flexWrap: "nowrap" }}
            >
              <Grid item>
                <Typography variant="body2" className={classes.span}>
                  (tCO<sub>2</sub>)
                </Typography>
              </Grid>
              <Grid
                container
                item
                alignItems="center"
                style={{ width: "fit-content", flexWrap: "nowrap" }}
              >
                <Typography variant="body2" style={{ marginRight: 4 }}>
                  By:
                </Typography>
                <Toggle
                  value={byFilter || defaultFilter}
                  options={BY_MY}
                  onChanged={setByFilter}
                  styles={{ width: 14 }}
                />
              </Grid>
            </Grid>
          </Grid>

          <Box className={classes.areaChart}>
              <StackedAreaChart
                data={data}
                areas={areas}
                unit="tCO2"
                onlyLeftRightXAxis
                hideXAxis
                hideYAxis
              />
          </Box>
        </div>
      ) : <NoDataCard title="Carbon Emission Reduction Over Time" />}
    </ShaDowBox>
  );
};
